<template>
    <div class="content">
        <!-- <div v-if="!isEdit"> -->
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="text">查询条件</span>
                </div>
                <div class="box-cont">
                    <el-form :model="queryParams" ref="queryForm" :inline="true">
                        <el-form-item label="监督单位名称:" prop="dwmc">
                            <el-input
                            v-model="queryParams.dwmc"
                            placeholder="请输入单位名称"
                            clearable
                            size="small"
                            @keyup.enter.native="handleQuery"
                            />
                        </el-form-item>
                        <el-form-item label="主办人:" prop="zbr">
                            <el-select v-model="queryParams.zbr" placeholder="请选择主办人" size="small" style="width:120px;">
                                <!-- v-for="(dict,index) in userOptions"
                                    :key="index" -->
                                <el-option
                                    v-for="dict in userOptions"
                                    :key="dict.dm"
                                    
                                    :label="dict.xm"
                                    :value="dict.xm"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="专业类别:" prop="zylb">
                            <el-select v-model="queryParams.zylb" placeholder="请选择专业类别" size="small">
                                <el-option
                                    v-for="dict in zylbOptions"
                                    :key="dict.ID"
                                    :label="dict.mc"
                                    :value="dict.ID"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="立案日期:" >
                            <el-date-picker size="small" clearable
                                v-model="queryParams.sj"
                                type="date"
                                placeholder="选择日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                            至
                            <el-date-picker size="small" clearable
                                v-model="queryParams.sj2"
                                type="date"
                                placeholder="选择日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="协办人:" prop="xbr">
                            <el-select v-model="queryParams.xbr" placeholder="请选择协办人" size="small" style="width:120px;">
                                <el-option
                                    v-for="dict in userOptions"
                                    :key="dict.dm"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                    ></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="案件状态:" prop="states">
                            <el-select v-model="queryParams.states" placeholder="请选择案件状态" size="small" style="width:120px;">
                                <!-- <el-option
                                    v-for="dict in ztOptions"
                                    :key="dict.id"
                                    :label="dict.city"
                                    :value="dict.city"
                                    ></el-option> -->
                                <el-option value="暂存">暂存</el-option>
                                <el-option value="保存">保存</el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                            <!-- <el-button type="warning"  :loading="isTb" size="small" @click="handleSjtb">数据同步</el-button> -->
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <span class="text">查询结果</span>
                    <p>案件数量:<b>{{total}}</b>个  注:黑色表示进行中，红色表示已完结</p>
                </div>
                <div class="box-cont">
                    <el-table v-loading="loading" :data="ajslList">
                        <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                            <template slot-scope="scope">
                                <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="决定书文号" prop="jdswh" />
                        <el-table-column label="监督对象名称" prop="dwmc" />
                        <el-table-column label="专业类别" align="center" prop="zylb" />
                        <el-table-column label="立案日期" prop="lian_rq" />
                        <el-table-column label="主办人" align="center" prop="host_man" />
                        <el-table-column label="协办人" align="center" prop="cooperate_man" />
                        <el-table-column label="案由" prop="reason2" />
                        <el-table-column label="关联状态" align="center" width="80px">
                            <template slot-scope="scope">
                                <span :style="{'color':scope.row.laiyuan ? '#46bb0d' : '#f00'}"><b>{{scope.row.laiyuan ? '已关联' : '未关联'}}</b></span>
                            </template>
                        </el-table-column>
                        <el-table-column label="状态" align="center" class-name="small-padding fixed-width" width="80" >
                            <template slot-scope="scope">
                                <span v-if="scope.row.states == '保存'" style="color:#46bb0d;"><b>已完结</b></span>
                                <el-button v-else
                                size="small"
                                type="text"
                                >{{scope.row.states}}</el-button>
                                
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="80" >
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.states == '保存'"
                                size="small"
                                type="text"
                                @click="handleEdit(scope.row,2)" style="color:#46bb0d;"
                            >查看</el-button>
                                <el-button v-else
                                size="small"
                                type="text"
                                @click="handleEdit(scope.row,1)"
                            >修改</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page-part" style="padding:20px 20px 50px;">
                        <el-pagination  v-if="pageshow"
                            background
                            @size-change='handleSizeChange'
                            @current-change='handleCurrentChange'
                            :current-page="queryParams.page"
                            :page-sizes="[10,20,30,40]"
                            :page-size="queryParams.limit"
                            layout="total, prev, pager, next, jumper"
                            :total="total" style=" float:right;">
                        </el-pagination>
                    </div>
                </div>
            </el-card>
        <!-- </div>
        <div v-if="isEdit">
            <baxq2 :ajId="this.ajId" :dwId="this.dwId" :dwFlag="this.dwFlag" :ajFlag="this.ajFlag" :isNew="2" :row="this.row" @handleBack="handleBack"  />
        </div> -->
    </div>
</template>

<script>
import Baxq2 from './baxq2.vue'
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            xm1:'',
            sj1:'',
            xm2:'',
            sj2:'',
            queryParams:{
                dwmc:'',
                zylb:'',
                zbr:'',
                xbr:'',
                zt:'',
                sj:'',
                sj2:'',
                states:'',
                page:1,
                limit:10,
            },
            total:0,
            ajslList:[],
            zylbOptions:[],
            userOptions:[],
            ztOptions:[],
            open:false,
            pageshow:true,
            ajId:'',
            dwId:'',
            dwFlag:'',
            ajFlag:'',
            row:'',
            isEdit:false,
            cmid:'',
            isTb:false,
            sc: "",
            xg: "",
            xz: "",
            baseUrl:''
        }
    },
    components: {
        Baxq2
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian,209)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '一般程序处罚案件列表'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.cmid = user.c_mid
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/lawEnforcer`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid
            }
        })
        .then(response => {
            this.userOptions = response.data.data || []
        })
        .catch(error => {
            this.$message.error('获取监督员数据失败！');
            console.error('There was an error!', error);
        });
        this.getList()
    },
    methods: {
        getList(){
            this.ajslList = []
            this.total = 0
            this.queryParams.zbr = this.queryParams.zbr ? this.queryParams.zbr : '全部'
            this.queryParams.xbr = this.queryParams.xbr ? this.queryParams.xbr : '全部'
            let year = new Date().getFullYear()
            this.queryParams.sj = this.queryParams.sj ? this.queryParams.sj : year+'-01-01'
            this.queryParams.sj2 = this.queryParams.sj2 ? this.queryParams.sj2 : this.getDate(new Date(),'yyyy-MM-dd')
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getybcxcfajlb`,
                data:{
                    zylb:this.queryParams.zylb,
                    dwmc:this.queryParams.dwmc,
                    states:this.queryParams.states,
                    ajflag:'',
                    sj:this.queryParams.sj,
                    sj2:this.queryParams.sj2,
                    zbr:this.queryParams.zbr,
                    xbr:this.queryParams.xbr,
                    cmid:this.cmid,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                this.loading = false
                if(res.data.code == 0 && res.data.data){
                    this.ajslList = res.data.data.list || []
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.loading = false
                this.$message.error(error);
            })
        },
        async handleSjtb(){
            this.isTb = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=setSxtData&c_mid=${this.cmid}`)
            console.log(data)
            this.isTb = false
            if(data.data){
                this.$message({
                    message: data.data[0].errMessage,
                    type: data.data[0].errMessage=='同步成功'?'success':'error'
                });
            }
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){},
        getCheck(){
            console.log(this.checkList)
        },
        handleEdit(row,val){
            // this.ajId = row.id
            // this.dwId = row.mid
            // this.ajFlag = row.ajflag
            // this.dwFlag = row.dw_flag
            // this.row = row
            // this.isEdit = true
            //this.$router.push({path:'/baxq',query:{ajId:row.id,dwId:row.mid,dwFlag:row.dw_flag,isNew:2}})
            let obj = encodeURIComponent(JSON.stringify(row))
            this.$router.push({name:'/baxq',
                query:{
                    isNew:2,
                    ajflag:row.ajflag,
                    dwId:row.mid,
                    lsh:row.lsh,
                    dwFlag:row.dw_flag,
                    ajId:row.id,
                    xgType:val
                },
                // params:{
                    
                //     row:obj,
                // }
            })

            // let url = this.$router.resolve({
            //     name:'/baxq',
            //     params:{
            //         // ajflag:row.ajflag,
            //         // dwId:row.mid,
            //         // lsh:row.lsh,
            //         // dwFlag:row.dw_flag,
            //         // ajId:row.id,
            //         // row:encodeURIComponent(JSON.stringify(row)),
            //         isNew:2
            //     }
            // })
            // window.open(url.href,'_self')
        },
        handleBack(){
            this.isEdit = false
            this.$forceUpdate()
        },
        resetQuery(){
            this.queryParams = {
                dwmc:'',
                zylb:'',
                zbr:'',
                xbr:'',
                zt:'',
                larq:'',
                states:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
    }
}
</script>


<style scoped>
</style>